// extracted by mini-css-extract-plugin
export default {"labelList":"LabelList_labelList__9cSJ5","labels":"LabelList_labels__suyAe"};